module.exports = __webpack_public_path__ + "img/in-logo.c20903a0.svg";